import { render, staticRenderFns } from "./incomeTable.vue?vue&type=template&id=92f6384a&scoped=true&"
import script from "./incomeTable.vue?vue&type=script&lang=js&"
export * from "./incomeTable.vue?vue&type=script&lang=js&"
import style0 from "./incomeTable.vue?vue&type=style&index=0&id=92f6384a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f6384a",
  null
  
)

export default component.exports